/**
 * Location Edit - video module
 *
 * Implements youtube video module
 *
 * @author Naiqiao Liang (nliang@yext.com)
 * @author MattJS (matt@yext.com)
 */
goog.provide('yext.location.video');

goog.require('yext');
goog.require('yext.dam.assetselector');
goog.require('yext.dam.assetselector.events');
goog.require('yext.dam.assetselector.usage');
goog.require('yext.dam.labels.view');
goog.require('yext.textfield');
goog.require('yext.videochooser');
goog.require('yext.youtube');
goog.require('yext.utils.youtube');

goog.scope(function() {
  var _video = yext.location.video;

  /**
   * Model that mirrors the VideoView.java backend model
   *
   * @param {!Object} data Video and display video data that mirrors the java model
   * @constructor
   */
  yext.location.video.VideoModel = function(data) {
    data = yext.isObject(data) ? data : {};

    this.video = new yext.location.video.VideoModel.Video(data.video);
    this.displayVideo = new yext.location.video.VideoModel.Video(data.displayVideo);

    // Youtube metadata. Copy needed for restore
    this.videoinfo = data.videoinfo;
  };

  /**
   * Used to update the models data
   *
   * @param {!Object} data Video and display video data that mirrors the java model
   */
  yext.location.video.VideoModel.prototype.update = function(data) {
    data = yext.isObject(data) ? data : {};
    if (data.videoinfo) { // Populated by youtube api
      this.videoinfo = data.videoinfo;
    }
    if (yext.isBoolean(data.indeterminate)) {
      this.indeterminate = data.indeterminate;
    }
    if (yext.isBoolean(data.displayIndeterminate)) {
      this.displayIndeterminate = data.displayIndeterminate;
    }
    this.video.update(data.video);
    this.displayVideo.update(data.displayVideo);
    // send an update message
    $(this).trigger('updated.video');
  };

  /**
   * Set the display video equal to the actual video
   */
  yext.location.video.VideoModel.prototype.setDisplayEqual = function() {
    this.displayVideo.clearAsset();
    this.displayVideo.update(this.video);
  };

  /**
   * Mirrors VideoView.Video java model
   *
   * @param {!Object} data Object containing url and asset info for the video
   * @constructor
   */
  yext.location.video.VideoModel.Video = function(data) {
    data = yext.isObject(data) ? data : {};

    this.url = yext.isString(data.url) ? data.url : '';
    this.asset = new yext.location.video.VideoModel.Video.Asset(data.asset);
    this.indeterminate = !!data.indeterminate;
  };

  /**
   * Update the video model with new url and asset data
   *
   * @param {!Object} data Object containing url and asset info for the video
   */
  yext.location.video.VideoModel.Video.prototype.update = function(data) {
    if (yext.isObject(data)) {
      if (yext.isString(data.url)) {
        this.url = data.url;
      }
      if (yext.isBoolean(data.indeterminate)) {
        this.indeterminate = data.indeterminate;
      }
      this.asset.update(data.asset);
    }
  };

  /**
   * Clear the asset on the video model
   */
  yext.location.video.VideoModel.Video.prototype.clearAsset = function() {
    this.asset = new yext.location.video.VideoModel.Video.Asset();
  };

  /**
   * Asset model for video model
   *
   * @param {!Object} data Object that contains id, name and labels for an asset
   * @constructor
   */
  yext.location.video.VideoModel.Video.Asset = function(data) {
    data = yext.isObject(data) ? data : {};

    this.id = data.id;
    this.name = data.name;
    this.labels = [];
    this.setLabels(data.labels);
  };

  /**
   * Update the asset object when a new video has been selected
   *
   * @param {!Object} data Object that contains id, name and labels for an asset
   */
  yext.location.video.VideoModel.Video.Asset.prototype.update = function(data) {
    if (yext.isObject(data)) {
      this.id = data.id;
      this.name = data.name;
      this.setLabels(data.labels);
    }
  };

  /**
   * Set the labels on an asset. During the inital set, mapLabels used to
   * get data ready for the asset selector
   *
   * @param {!Array} data Array of asset labels as strings or objects with key 'name'
   */
  yext.location.video.VideoModel.Video.Asset.prototype.setLabels = function(data) {
    if (Array.isArray(data)) {
      if (yext.isString(data[0])) {
        this.labels = this.mapLabels(data);
      } else { // Assumes this is an object set by assetselector
        this.labels = data;
      }
    }
  };

  /**
   * Format the labels list as objects instead of strings for compatibility
   * with the assetselector
   *
   * @param {!Array.String} List of strings with asset labels
   * @return {!Array} List of label objects with key 'name'
   */
  yext.location.video.VideoModel.Video.Asset.prototype.mapLabels = function(data) {
    return data.map(function(labelName) {
      return {
        name: labelName,
      };
    });
  };

  /**
   * Video View Controller
   *
   * @param {!jQuery} $element A parent container for the edit/display elements
   * @param {string} context the html tag containing the $element
   * @param {LocationField} locationField
   * @constructor
   */
  _video.VideoController = function($element, context, locationField) {
    this.$element = $element;
    this.$row = $element.closest(context);
    this.$display = this.$row.find('.js-single-video-display');
    this.templateHtml = $element.find('.js-video-display-template').html();

    this.model = this.getVideoData();
    this.locationField = locationField;

    this.fieldName = this.$element.data('fieldId');
    this.textField = yext.textfield.createWithUsageType(this.$element.find('.js-text-field'), this.fieldName);

    this.initalFetchVideo();
    this.bindAddVideo();
    this.bindRemoveVideo();
    this.bindDescriptionUpdate();
    this.bindVideoUpdate();
  };

  /**
   * Get the initial metadata from youtube
   */
  _video.VideoController.prototype.initalFetchVideo = function() {
    if (this.model.displayVideo.url) {
      var self = this;
      this.fetchVideoFromYoutube(function(videoinfo) {
        self.model.videoinfo = videoinfo;
        self.saveValue();
        self.updateVideoDisplay(self.$display);
        self.renderDisplayVideoLabels();
        if (self.model.video.url) {
          self.updateVideoDisplay(self.$element);
          self.renderVideoLabels();
        }
      });
    } else {
      this.saveValue();
    }
  };

  /**
   * Get video data from the video view serialized object.s
   *
   * @return {VideoModel} Video model
   */
  _video.VideoController.prototype.getVideoData = function() {
    var data = this.$element.data('videoData');
    return new yext.location.video.VideoModel(data);
  };


  /**
   * Store the video model for restoring on cancel
   */
  _video.VideoController.prototype.saveValue = function() {
    this.storedModel = new yext.location.video.VideoModel(this.model);
    this.textField.saveValue();
  };

  /**
   * 'Add youtube video' links
   *
   * Bind click events to show the add youtube video dialog
   */
  _video.VideoController.prototype.bindAddVideo = function() {
    var self = this;
    this.$element.find('.js-add-video').on('click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      self.showAssetSelector();
    });
  };

  /**
   * Show/bind the asset selector
   */
  _video.VideoController.prototype.showAssetSelector = function() {
    var self = this;
    var selectorUsage = goog.module.get('yext.dam.assetselector.usage');
    yext.dam.assetselector.show({
      type: yext.dam.assetselector.types.VIDEO,
      includeUsedAssets: false,
      isSuggestedEditMode: this.getIsSuggestedEditMode(),
      usageType: selectorUsage.forProfileFields(self.fieldName),
    },
    this.fieldName);
    $(yext.dam.assetselector.events).on('added.assetselector', function(e, asset) {
      self.updateVideoData(asset);
      self.model.setDisplayEqual(); // Copy over asset labels
      self.render();
      if (self.locationField) {
        self.locationField.toggleEdit(true);
      }
    });
  };

  /**
   * Checks for isSuggestedEditMode when locationField might be undefined
   *
   * @return {boolean} Whether it is in suggested edit mode or not
   */
  _video.VideoController.prototype.getIsSuggestedEditMode = function() {
    if (this.locationField) {
      return this.locationField.isSuggestEditMode;
    }
    return false;
  };

  /**
   * updateVideoData update the video data on ajax call back (video selector)
   *
   * @param {!Object} asset the video asset including meta
   */
  _video.VideoController.prototype.updateVideoData = function(asset) {
    this.model.update({
      videoinfo: asset.videoinfo,
      video: {
        asset: {
          id: asset.id,
          name: asset.name,
          labels: asset.labels,
        },
        url: asset.videoinfo.url,
        indeterminate: false,
      },
    });
    this.textField.set({
      value: asset.description,
      displayValue: asset.description,
    });
  };

  /**
   * updateVideoDisplay updates the video display with a giving youtube url
   * @param {jqueryObject} video view object or video edit object
   */
  _video.VideoController.prototype.updateVideoDisplay = function($el) {
    var html = '';
    if (this.model.videoinfo) {
      html = yext.utils.youtube.fixupVideoTemplate(this.templateHtml, this.model.videoinfo);
    } else {
      this.showError(
        yext.msg(
          'There was an error retrieving video details from Youtube.' +
          ' The <a href="{0}">video</a> may be private or unavailable.',
          this.model.video.url));
    }
    $el.find('.js-video-display').html(html).show();
  };

  /**
   * Bind click events to show the remove youtube video dialog
   */
  _video.VideoController.prototype.bindRemoveVideo = function() {
    var $dialog = this.$element.find('.js-rm-video-dialog');
    var self = this;
    var removeDialog = $dialog.dialog({
      modal: true,
      draggable: false,
      resizable: false,
      autoOpen: false,
      title: yext.msg('Are you sure you want to remove this video?'),
      width: 355,
      height: 100,
    });

    $dialog.find('.danger').click(function() {
      self.remove();
      // add location
      if (self.locationField === undefined) {
        self.$row.find('.js-add-video-link').show();
      }
      removeDialog.dialog('close');
    });

    $dialog.find('.cancel').click(function() {
      removeDialog.dialog('close');
    });

    this.$element.find('.js-remove-video')
      .off('click')
      .on('click', function(e) {
        e.stopPropagation();
        e.preventDefault();
        removeDialog.dialog('open');
      });
  };

  /**
   * Bind updates to description
   */
  _video.VideoController.prototype.bindDescriptionUpdate = function() {
    var self = this;
    $(this.textField).on('update.textField', function() {
      $(self).trigger('update.video');
    });
  };

  /**
   * Bind updates to video
   */
  _video.VideoController.prototype.bindVideoUpdate = function() {
    var self = this;
    $(this.model).on('updated.video', function() {
      $(self).trigger('update.video');
    });
  };

  /**
   * Update video asset labels
   *
   * @param {JQueryObject} $el is the container of the labels
   * @param {Video.Asset} asset Details about the video asset for rendering labels
   */
  _video.renderLabels = function($el, asset) {
    if (asset && asset.id) {
      var $label = yext.dam.labels.view.getAssetViewLabel(asset);
      if ($label) {
        $el.find('.js-video-thumbnail').append($label);
      }
    }
  };

  _video.VideoController.prototype.renderVideoLabels = function() {
    _video.renderLabels(this.$element, this.model.video.asset);
  };

  _video.VideoController.prototype.renderDisplayVideoLabels = function() {
    _video.renderLabels(this.$display, this.model.displayVideo.asset);
  };

  /**
   * Bind location edit page features
   */
  _video.VideoController.prototype.locationEditFeatures = function() {
    // If there's no location field the video may be loaded as a suggested edit
    // original location therefore don't bind edit features
    if (!this.locationField) {
      return;
    }
    var self = this;
    $(this).on('update.video', function() {
      self.locationField.field.enableSubmit();
    });

    $(this.locationField.$form).on('beforeSubmit.field', function() {
      self.setInputValues();
      self.locationField.field.disableSubmit();
    });

    $(this.locationField.$form).on('save.field', function(e, response) {
      // Reset the field after suggested edit
      if (response.suggestedEditIds) {
        // Location Edit Field Flow, suggestedEdits should be handled elsewhere now
        self.reset();
        return;
      } else if (response.field) {
        self.refresh(response.field);
      } else if (response.error) {
        if (self.beforeDelete) {
          self.resetInternal(self.beforeDelete);
          self.beforeDelete = undefined;
        }
      }
    });

    $(this.locationField).on('toggleFieldEdit', function(e, show) {
      // if no video, dont enter edit mode but open dialog instead
      if (show && self.model.video.url === ''
          && !self.model.video.indeterminate
          && self.$element.find('.js-field-error:visible').length == 0) {
        self.showAssetSelector();
        self.locationField.toggleEdit(false);
      }
    });

    this.$row.find('.js-cancel-edit').click(function() {
      self.reset();
    });
  };

  /**
   * Set the hidden input values
   */
  _video.VideoController.prototype.setInputValues = function() {
    var video = this.model.video;
    if (video.asset) {
      if (video.asset.id) {
        this.$element.find('input[name="' + this.fieldName + '.assetId"]').val(video.asset.id);
      } else {
        this.$element.find('input[name="' + this.fieldName + '.assetId"]').val(0);
      }
      if (video.asset.name) {
        this.$element.find('input[name="' + this.fieldName + '.assetName"]').val(video.asset.name);
      } else if (this.model.videoinfo) {
        this.$element.find('input[name="' + this.fieldName + '.assetName"]').val(this.model.videoinfo.title);
      }
    }
    this.$element.find('input[name="' + this.fieldName + '.url"]').val(video.url);
  };

  /**
   * Reset video field
   */
  _video.VideoController.prototype.reset = function() {
    this.textField.reset();
    this.resetInternal(new yext.location.video.VideoModel(this.storedModel));
    this.locationField.field.disableSubmit();
  };

  _video.VideoController.prototype.resetInternal = function(model) {
    this.model = model;
    this.bindVideoUpdate();
    this.render();
  };

  /**
   * Get updated metadata from youtube so video preview can be rendered
   *
   * @param {function()} cb Callback for when finished
   */
  _video.VideoController.prototype.fetchVideoFromYoutube = function(cb) {
    var self = this;
    var youtubeId = yext.youtube.parseIdFromUrl(this.model.displayVideo.url);
    yext.youtube.getVideosDetails([youtubeId], function(videos) {
      cb(videos[0]);
    }, function() {
      // Error and we have no idea why
      self.showError();
      cb();
    });
  };

  /**
   * Show an error when something goes wrong
   *
   * @param {string} msg Error message to display
   */
  _video.VideoController.prototype.showError = function(msg) {
    msg = msg || yext.msg('Something went wrong, please reload the page');
    this.$element.find('.js-field-error').html(msg).show();
  };

  /**
   * Render the view and edit modes
   */
  _video.VideoController.prototype.render = function() {
    // Render edit mode
    this.$element.find('.js-video-edit-various').toggle(this.model.video.indeterminate);
    this.$element.find('.js-description-control').toggle(!this.model.video.indeterminate && !!this.model.video.url);
    this.$element.find('.js-video-actions').show();
    this.$element.find('.js-video-display').empty();

    if (this.model.video.url) {
      this.updateVideoDisplay(this.$element);
      this.renderVideoLabels();
    } else if (!this.model.video.indeterminate) {
      this.$element.find('.js-video-actions').hide();
    }

    // Render view mode
    var hasDeterminateVideo = !!this.model.displayVideo.url;
    var $addVideo = this.$row.find('.js-add-video-link');
    this.$display.find('.js-video-various').hide();
    this.$display.find('.js-video-display').empty();
    $addVideo.hide();
    if (this.model.displayVideo.indeterminate) {
      this.$display.find('.js-video-various').show();
    } else if (hasDeterminateVideo) {
      this.updateVideoDisplay(this.$display);
      this.renderDisplayVideoLabels();
      this.$display.find('.js-video-description')
        .empty()
        .append(this.textField.viewMarkup())
        .show();
    } else {
      $addVideo.show();
    }

    this.$display.find('.js-video-display-wrapper').toggle(hasDeterminateVideo);

    // Description display should be hidden when on alternate profile and
    // inheriting from primary when description is empty
    if (!this.textField.displayValue()
        && this.model.displayVideo.url
        && !this.model.video.url) {
      this.$display.find('.js-video-description-display').hide();
    } else {
      this.$display.find('.js-video-description-display').show();
    }
  };

  /**
   * Refresh the video field after saving, it leaves edit mode and enters show mode
   *
   * @param {!Object} field Response from server after save
   * @param {boolean} updateVideo whether to update the field and edit displays with the response video
   */
  _video.VideoController.prototype.refresh = function(field) {
    var self = this;
    var videoUpdated = false;

    if (this.model.video.url || field.displayVideo.url) {
      videoUpdated = this.model.video.url != field.displayVideo.url;
    }

    this.model.update(field);
    this.textField.set(field.video.description);

    if (videoUpdated) {
      this.fetchVideoFromYoutube(function(videoinfo) {
        self.model.videoinfo = videoinfo;
        self.saveValue();
        self.render();
      });
    } else {
      this.saveValue();
      this.render();
    }
  };

  /**
   * Submit form with remove video data or clear form data
   */
  _video.VideoController.prototype.remove = function() {
    this.beforeDelete = new yext.location.video.VideoModel(this.model);
    this.model.update({
      video: {
        url: '',
      },
    });
    this.model.video.clearAsset();
    this.model.setDisplayEqual();

    if (this.locationField) {
      this.locationField.field.$form.submit();
    } else {
      this.render();
    }
  };
});
